<template>
  <div style="width:100%; padding-top: 60px;">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">关闭</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>
    <van-collapse v-model="activeNames">
      <van-collapse-item title="档案信息目录" name="1">
        <van-field v-model="inputForm.deptName" label="归档部门" label-width='100px' input-align="left" :border="false" readonly autosize rows="1"
                   type="textarea" readonly />
        <van-field v-model="inputForm.projectName" label="档案所属项目" label-width='100px' input-align="left" :border="false" readonly autosize rows="1"
                   type="textarea" readonly />
        <van-field v-model="inputForm.docTypeName" label="档案类别" label-width='100px' input-align="left" :border="false" readonly autosize rows="1"
                   type="textarea" readonly />
        <van-field v-model="inputForm.archiveName" label="档案名称" label-width='100px' input-align="left" :border="false" readonly autosize rows="1"
                   type="textarea" readonly />
        <van-field v-model="inputForm.archiveAddress" label="档案存放地" label-width='100px' input-align="left" :border="false" readonly autosize rows="1"
                   type="textarea" readonly />
        <div style="padding-left: 16px;" v-show="inputForm.attachList.length > 0">
          <p>附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
      </van-collapse-item>
    </van-collapse>

    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import ArchiveInfoService from '@/api/archive/ArchiveInfoService.js'
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import processRecord from "../../components/processRecord/processRecord";
export default {
  data() {
    return {
      dateinfo: '',
      activeNames: ['1', '2', '3'],
      isshow: false,
      radio: '',
      inputForm: {
        id: '',
        projectName: '',
        title: '',
        content: '',
        summary: '',
        license: '',
        auditStatus: '1',
        isEnabled: '1',
        attachIds: [],
        attachList: [],
        docTypeName: '',
        deptName: '',
        archiveName: '',
        archiveAddress: '',
        isDoTask: false,
        isLastTask: false,
      },
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type: ''
    }
  },
  components: {
    processRecord
  },
  mounted() {
  },

  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },

    init: function (id) {
      new ArchiveInfoService().queryById(id).then(({data}) => {
        this.inputForm = data
      }).catch(e => {
      })
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = _this.inputForm.isLastTask ? 4 : 2;
          new ArchiveInfoService().startFlow(_this.inputForm);

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = 3;
          new ArchiveInfoService().startFlow(_this.inputForm);

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    }
  }
}
</script>
